import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { makeStyles } from '@mui/styles'
import { styled, Theme } from '@mui/material/styles'
import { Typography, Divider, Tooltip, Link, Button, IconButton } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBackIosNewOutlined'
import InfoIcon from '@mui/icons-material/InfoOutlined'
import DistanceIcon from '@mui/icons-material/Straighten'
import AzimuthIcon from '@mui/icons-material/NavigationOutlined'
import CommentIcon from '@mui/icons-material/RateReviewOutlined'
import Drawer from '../../control/Drawer'
import Scrollbar from '../../control/Scrollbar'
import useStationDetail from '../../hooks/map/useStationDetail'
import { calculateMidFrequency, getDecimalBySpecificDigit, formatTelephoneNumberOnly } from '../../util/utilityFunction'
import MapStationDetailMux from './MapStationDetailMux'
import PrivacyPolicyDialog from './PrivacyPolicyDialog'

type MapStationDetailProps = {
    onClose: () => void
    dataContact?: ContactUsType
    data?: StationType | null
    isOpen: boolean
}
const MapStationDetail = (props: MapStationDetailProps) => {
    const [result, setResult] = useState<StationType>()
    const { onClose, data, isOpen } = props
    const {
        isMobileDevice,
        dataContact,
        muxData,
        titleMuxDetail,
        openMuxDetail,
        onClickMuxDetail,
        onCloseMuxDetail,
        onClickSuggest,
        showPrivacyPolicy,
        handlerPolicyAccepted,
        handlerPolicyPopupClosed,
    } = useStationDetail()
    const { t } = useTranslation()
    const classes = useStyles()

    useEffect(() => {
        if (data && data.station_id) {
            setResult(data)
        }
    }, [data])

    const getItemMUX = (data?: StationType) => {
        return (
            <StyledContainerMUXList>
                {Array.from(Array(parseInt(`${process.env.REACT_APP_MUX_MAX}`)).keys()).map(
                    (no: number, index: number) => {
                        if (data?.[`mux${no + 1}`]?.frequency_actual) {
                            return (
                                <StyledContainerMUXItem key={index}>
                                    <StyledDivMUXTitle>
                                        <div>
                                            <StyledTypoMUXTitle>{`MUX${no + 1}`}</StyledTypoMUXTitle>
                                        </div>
                                        <div>
                                            <Tooltip
                                                title={data?.[`mux${no + 1}`]?.provider}
                                                placement="right-end"
                                                onClick={() => {
                                                    onClickMuxDetail(`MUX ${no + 1}`, data?.[`mux${no + 1}`])
                                                }}
                                                classes={{ tooltip: classes.tooltip }}
                                            >
                                                <IconButton>
                                                    <StyledIconInfo />
                                                </IconButton>
                                            </Tooltip>
                                        </div>
                                    </StyledDivMUXTitle>
                                    {data?.[`mux${no + 1}`]?.frequency_plan && (
                                        <>
                                            <StyledDivMUXRow>
                                                <StyledDivMUXColumn2
                                                    style={{
                                                        width: data?.[`mux${no + 1}`]?.frequency_plan ? '20%' : '30%',
                                                    }}
                                                >
                                                    {t('LABEL.MAP.STATION.PRESENT')}
                                                </StyledDivMUXColumn2>
                                                {data?.[`mux${no + 1}`]?.frequency_plan && (
                                                    <StyledDivMUXColumn3>
                                                        {t('LABEL.MAP.STATION.FUTURE')}
                                                    </StyledDivMUXColumn3>
                                                )}
                                            </StyledDivMUXRow>
                                            <Divider className={classes.dividerMUX} />
                                        </>
                                    )}

                                    <StyledDivMUXRow>
                                        <StyledDivMUXColumn1
                                            style={{ width: data?.[`mux${no + 1}`]?.frequency_plan ? '60%' : '70%' }}
                                        >
                                            {`${t('LABEL.MAP.STATION.CHANNEL_FREQUENCY')} :`}
                                        </StyledDivMUXColumn1>
                                        <StyledDivMUXColumn2
                                            style={{ width: data?.[`mux${no + 1}`]?.frequency_plan ? '20%' : '30%' }}
                                        >
                                            {data?.[`mux${no + 1}`]?.frequency_actual || '-'}
                                        </StyledDivMUXColumn2>
                                        {data?.[`mux${no + 1}`]?.frequency_plan && (
                                            <StyledDivMUXColumn3>
                                                {data?.[`mux${no + 1}`]?.frequency_plan}
                                            </StyledDivMUXColumn3>
                                        )}
                                    </StyledDivMUXRow>
                                    <StyledDivMUXRow>
                                        <StyledDivMUXColumn1
                                            style={{ width: data?.[`mux${no + 1}`]?.frequency_plan ? '60%' : '70%' }}
                                        >
                                            {`${t('LABEL.MAP.STATION.MID_FREQUENCY')} (${t(
                                                'LABEL.MAP.STATION.MID_FREQUENCY_UNIT',
                                            )}) :`}
                                        </StyledDivMUXColumn1>
                                        <StyledDivMUXColumn2
                                            style={{ width: data?.[`mux${no + 1}`]?.frequency_plan ? '20%' : '30%' }}
                                        >
                                            {calculateMidFrequency(data?.[`mux${no + 1}`]?.frequency_actual) || '-'}
                                        </StyledDivMUXColumn2>
                                        {data?.[`mux${no + 1}`]?.frequency_plan && (
                                            <StyledDivMUXColumn3>
                                                {calculateMidFrequency(data?.[`mux${no + 1}`]?.frequency_plan)}
                                            </StyledDivMUXColumn3>
                                        )}
                                    </StyledDivMUXRow>
                                </StyledContainerMUXItem>
                            )
                        }
                    },
                )}
            </StyledContainerMUXList>
        )
    }

    return (
        <>
            <PrivacyPolicyDialog
                show={showPrivacyPolicy}
                onAcceptPolicy={handlerPolicyAccepted}
                onClose={handlerPolicyPopupClosed}
            />
            <Drawer
                hideBackdrop
                isOpen={isOpen}
                inlineStyle={{ position: 'unset' }}
                overrideClass={{ paper: classes.drawerPaper }}
            >
                <StyledContainer>
                    <StyledTitle>
                        <IconButton
                            aria-label="close"
                            onClick={onClose}
                            sx={{
                                position: 'absolute',
                                left: 10,
                                top: 15,
                            }}
                            className={classes.backIcon}
                        >
                            <ArrowBackIcon />
                        </IconButton>
                        <StyledTypography variant="body2">ข้อมูลสถานีส่งสัญญาณ</StyledTypography>
                    </StyledTitle>
                    <StyledContent>
                        <div style={{ width: '100%', height: '100%' }}>
                            <Scrollbar scrollbarTrackBorderRadius={10} scrollbarThumbBorderRadius={10}>
                                <StyledContentGroup>
                                    {/* ชื่อสถานี */}
                                    <StyledDivRow>
                                        <StyledDivColumnLeft>
                                            <Typography>ชื่อสถานี :</Typography>
                                        </StyledDivColumnLeft>
                                        <StyledDivColumnRight>
                                            <Typography>{result?.name_th}</Typography>
                                        </StyledDivColumnRight>
                                    </StyledDivRow>
                                    {/* ประเภทสถานี */}
                                    <StyledDivRow>
                                        <StyledDivColumnLeft>
                                            <Typography>ประเภทสถานี :</Typography>
                                        </StyledDivColumnLeft>
                                        <StyledDivColumnRight>
                                            <Typography>{result?.station_type}</Typography>
                                        </StyledDivColumnRight>
                                    </StyledDivRow>
                                    {/* ERP */}
                                    <StyledDivRow>
                                        <StyledDivColumnLeft>
                                            <Typography>ค่ากำลังส่งออกอากาศ (ERP) :</Typography>
                                        </StyledDivColumnLeft>
                                        <StyledDivColumnRight>
                                            <Typography>{result?.erp ? result?.erp + ' kW' : '-'}</Typography>
                                        </StyledDivColumnRight>
                                    </StyledDivRow>
                                    {/* Height */}
                                    <StyledDivRow>
                                        <StyledDivColumnLeft>
                                            <Typography>ความสูงสายอากาศ :</Typography>
                                        </StyledDivColumnLeft>
                                        <StyledDivColumnRight>
                                            <Typography>{result?.height ? result?.height + ' m' : '-'}</Typography>
                                        </StyledDivColumnRight>
                                    </StyledDivRow>
                                    {/* พิกัดตำแหน่งที่ตั้ง */}
                                    <StyledDivRow>
                                        <StyledDivColumnLeft>
                                            <Typography>พิกัดตำแหน่งที่ตั้ง :</Typography>
                                        </StyledDivColumnLeft>
                                        <StyledDivColumnRight>
                                            <Typography>
                                                {result?.latitude && result?.longitude
                                                    ? getDecimalBySpecificDigit(result?.latitude) +
                                                      ', ' +
                                                      getDecimalBySpecificDigit(result?.longitude)
                                                    : '-'}
                                            </Typography>
                                        </StyledDivColumnRight>
                                    </StyledDivRow>
                                    {/* ผู้รับผิดชอบสถานี */}
                                    <StyledDivRow>
                                        <StyledDivColumnLeft>
                                            <Typography>ผู้รับผิดชอบสถานี :</Typography>
                                        </StyledDivColumnLeft>
                                        <StyledDivColumnRight>
                                            <Typography>{result?.owner}</Typography>
                                        </StyledDivColumnRight>
                                    </StyledDivRow>
                                    {/* ที่อยู่ */}
                                    <StyledDivRow>
                                        <StyledDivColumnLeft>
                                            <Typography>{`${t('LABEL.BACKOFFICE.CONTACT.ADDRESS')} : `}</Typography>
                                        </StyledDivColumnLeft>
                                        <StyledDivColumnRight>
                                            <Typography>{result?.address}</Typography>
                                        </StyledDivColumnRight>
                                    </StyledDivRow>
                                    {/* distance */}
                                    {result?.distance !== undefined &&
                                        result?.distance !== null &&
                                        result?.displayAzimuthAndDistance && (
                                            <StyledDivRow>
                                                <DistanceIcon className={classes.icon} />
                                                <Typography>{result?.distance}</Typography>
                                            </StyledDivRow>
                                        )}
                                    {/* azimuth */}
                                    {result?.azimuth !== undefined &&
                                        result?.azimuth !== null &&
                                        result?.displayAzimuthAndDistance && (
                                            <StyledDivRow>
                                                <AzimuthIcon className={classes.icon} />
                                                <Typography>{`มุมเทียบกับทิศเหนือ ${
                                                    (result?.azimuth !== undefined &&
                                                        result?.azimuth !== null &&
                                                        result?.azimuth.toFixed(0) + '°') ||
                                                    '-'
                                                }`}</Typography>
                                            </StyledDivRow>
                                        )}

                                    <Divider className={classes.divider} />

                                    <StyledTypoSectionTitle>ข้อมูลผู้ให้บริการ</StyledTypoSectionTitle>
                                    <StyledContainerMUX>{data && getItemMUX(data)}</StyledContainerMUX>
                                    {result?.remark?.trim() && (
                                        <StyledTypoRemarks variant="caption">{`หมายเหตุ : ${result?.remark}`}</StyledTypoRemarks>
                                    )}

                                    {result?.displayAzimuthAndDistance && (
                                        <>
                                            <Divider className={classes.divider} />
                                            <StyledDivContact>
                                                <StyledTypoContact>
                                                    <label style={{ color: '#d32f2f' }}>{'** '}</label>
                                                    {'กรณีใช้งานไม่ได้ กรุณาติดต่อ'}
                                                </StyledTypoContact>
                                            </StyledDivContact>
                                            <StyledDivContact>
                                                <StyledTypoCallCenter>
                                                    {'Call Center '}
                                                    {!isMobileDevice &&
                                                        formatTelephoneNumberOnly(dataContact?.callCenter || '')}
                                                    {isMobileDevice && (
                                                        <StyledLink
                                                            href={`tel:${formatTelephoneNumberOnly(
                                                                dataContact?.callCenter || '',
                                                            )}`}
                                                        >
                                                            {formatTelephoneNumberOnly(dataContact?.callCenter || '')}
                                                        </StyledLink>
                                                    )}
                                                </StyledTypoCallCenter>
                                            </StyledDivContact>
                                            <StyledDivButton>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={() => {
                                                        // onClose()
                                                        onClickSuggest(data)
                                                    }}
                                                    startIcon={<CommentIcon />}
                                                    classes={{ root: classes.button }}
                                                >
                                                    เขียนข้อเสนอแนะ
                                                </Button>
                                            </StyledDivButton>
                                        </>
                                    )}
                                </StyledContentGroup>
                            </Scrollbar>
                        </div>
                    </StyledContent>
                </StyledContainer>
            </Drawer>
            <MapStationDetailMux
                data={muxData}
                title={titleMuxDetail}
                isOpen={openMuxDetail}
                onClose={onCloseMuxDetail}
            />
        </>
    )
}

export default MapStationDetail

const useStyles = makeStyles((theme: Theme) => ({
    drawerPaper: {
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
    container: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    backIcon: {
        color: `${theme.palette.text.secondary} !important`,
    },
    divButton: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginLeft: theme.spacing(1),
    },
    icon: {
        color: `${theme.palette.primary.dark} !important`,
        marginRight: theme.spacing(1),
    },
    divider: {
        margin: '10px 0px !important',
    },
    dividerMUX: {
        margin: '5px 0px !important',
    },
    tooltip: {
        margin: '0px !important',
    },
    button: {
        width: '170px',
        minHeight: '37px',
        fontSize: '14px !important',
    },
}))

const StyledContainer = styled('div')(({ theme }) => ({
    width: '350px',
    height: '100%',
    [theme.breakpoints.down('sm')]: {
        width: '100%',
    },
}))

const StyledTitle = styled('div')(({ theme }) => ({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px 0px',
    backgroundColor: theme.palette.secondary.main,
    boxShadow: theme.palette.getContrastText('shadow-bottom'),
}))

const StyledTypography = styled(Typography)(({ theme }) => ({
    color: theme.palette.text.secondary,
    textAlign: 'center',
}))

const StyledContent = styled('div')(({ theme }) => ({
    display: 'flex',
    height: `calc(100% - 63px)`,
}))

const StyledContentGroup = styled('div')(({ theme }) => ({
    margin: '20px',
}))

const StyledDivRow = styled('div')(({ theme }) => ({
    display: 'flex',
    width: '100%',
    margin: '5px 0px',
}))

const StyledDivColumnLeft = styled('div')(({ theme }) => ({
    [theme.breakpoints.up('sm')]: {
        whiteSpace: 'nowrap',
    },
    [theme.breakpoints.down('sm')]: {
        width: '40%',
    },
}))

const StyledDivColumnRight = styled('div')(({ theme }) => ({
    [theme.breakpoints.up('sm')]: {
        marginLeft: '15px',
    },
    [theme.breakpoints.down('sm')]: {
        marginLeft: '10px',
        width: '60%',
        display: 'flex',
        alignItems: 'center',
    },
}))

const StyledTypoSectionTitle = styled(Typography)(({ theme }) => ({
    color: `${theme.palette.secondary.dark} !important`,
    fontWeight: 'bold',
}))

const StyledContainerMUX = styled('div')(({ theme }) => ({
    padding: '5px 0px',
}))

const StyledTypoRemarks = styled(Typography)(({ theme }) => ({
    fontSize: '12px',
}))

const StyledContainerMUXList = styled('div')(({ theme }) => ({
    width: '100%',
    margin: '5px 0px',
}))

const StyledContainerMUXItem = styled('div')(({ theme }) => ({
    border: `1px solid ${theme.palette.text.disabled}`,
    borderRadius: '3px',
    backgroundColor: '#f0f7ff',
    padding: '5px 10px 10px 10px',
    marginBottom: '10px',
}))

const StyledDivMUXTitle = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
}))

const StyledTypoMUXTitle = styled(Typography)(({ theme }) => ({
    color: `${theme.palette.primary.dark} !important`,
    fontSize: '14px',
    fontWeight: 'bold',
}))

const StyledDivMUXRow = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'right',
}))

const StyledDivMUXColumn1 = styled('div')(({ theme }) => ({}))

const StyledDivMUXColumn2 = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
}))

const StyledDivMUXColumn3 = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    color: theme.palette.text.disabled,
}))

const StyledIconInfo = styled(InfoIcon)(({ theme }) => ({
    fontSize: '15px',
}))

const StyledDivContact = styled('div')(({ theme }) => ({
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
}))

const StyledDivButton = styled('div')(({ theme }) => ({
    width: '100%',
    padding: '10px 0px 5px 0px',
    display: 'flex',
    justifyContent: 'center',
}))

const StyledTypoContact = styled(Typography)(({ theme }) => ({
    fontSize: '14px',
}))

const StyledTypoCallCenter = styled(Typography)(({ theme }) => ({
    fontSize: '14px',
    color: theme.palette.primary.main,
}))

const StyledLink = styled(Link)(({ theme }) => ({
    color: `${theme.palette.primary.main} !important`,
}))
